import CompetitionPage from "../../common/components/CompetitionPage";
import { REWARD_OFFERING } from "../../constants";

function WgtExtraMain() {
  const offerId = REWARD_OFFERING.wgtextra;

  return (
    <CompetitionPage
      offerId={offerId}
      loadingMessage="Submitting your WGT Extra entry..."
    />
  );
}

export default WgtExtraMain;
